import React from 'react';
import {ClientDocumentList} from "./ClientDocumentList";
import {clientDocumentListReducer, initState} from "./clientDocumentReducer";

type ClientProfileDocumentFileListPageParams = {
    clientGuid: string
}

export function ClientProfileDocumentFileListPage({clientGuid}: ClientProfileDocumentFileListPageParams) {
    const [{
        pagination,
        sortBy,
        documentTypeFilter,
        searchFilter
    }, dispatch] = React.useReducer(clientDocumentListReducer, initState())

    return (
        <ClientDocumentList
            clientGuid={clientGuid}
            sortBy={sortBy}
            documentTypeFilter={documentTypeFilter}
            pagination={pagination}
            dispatch={dispatch}
            searchText={searchFilter}
        />
    );
}
